"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Discussion = babelHelpers.interopRequireDefault(require("tab/Discussion"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _Overview = babelHelpers.interopRequireDefault(require("tab/Overview"));

var _formatters = require("formatters");

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _temp;

var ForumDiscussionTab = (_class = (_temp =
/*#__PURE__*/
function (_DiscussionTab) {
  babelHelpers.inherits(ForumDiscussionTab, _DiscussionTab);

  function ForumDiscussionTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ForumDiscussionTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ForumDiscussionTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "discussionStarter", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ForumDiscussionTab, [{
    key: "render",
    value: function render() {
      if (!this.discussionStarter) {
        return babelHelpers.get(babelHelpers.getPrototypeOf(ForumDiscussionTab.prototype), "render", this).call(this);
      }

      return _react.default.createElement(_react.Fragment, null, this.discussionStarter.submitter ? _react.default.createElement("section", {
        className: "discussion topic-starter"
      }, _react.default.createElement("div", {
        className: "comment-list"
      }, _react.default.createElement("div", {
        className: "comment-thread"
      }, _react.default.createElement("article", {
        className: "comment-item",
        id: "topic-".concat(this.discussionStarter.id)
      }, _react.default.createElement("header", null, _react.default.createElement("div", {
        className: "photo"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "userProfilePhoto",
        noImageClassName: "initials",
        image: this.discussionStarter.submitter.photo,
        name: this.discussionStarter.submitter.name
      })), _react.default.createElement("div", {
        className: "info-block"
      }, _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement("span", {
        className: "person-name"
      }, this.discussionStarter.submitter.name), this.discussionStarter.submitter.title && _react.default.createElement("span", {
        className: "person-title"
      }, this.discussionStarter.submitter.title), this.discussionStarter.submitter.location && _react.default.createElement("span", {
        className: "person-location"
      }, this.discussionStarter.submitter.location)), _react.default.createElement("div", {
        className: "comment-time"
      }, _react.default.createElement("time", {
        dateTime: this.discussionStarter.date
      }, (0, _formatters.formatDateInterval)(this.discussionStarter.date))))), _react.default.createElement("div", {
        className: "comment comment-text",
        dangerouslySetInnerHTML: {
          __html: this.discussionStarter.description
        }
      }))))) : this.discussionStarter.description ? _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText"
      }, _react.default.createElement("div", {
        className: "inner-content container",
        dangerouslySetInnerHTML: {
          __html: this.discussionStarter.description
        }
      })) : null, babelHelpers.get(babelHelpers.getPrototypeOf(ForumDiscussionTab.prototype), "render", this).call(this));
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(ForumDiscussionTab), "value", this).call(this, object, page, tab);

      if (r) {
        Object.assign(r, {
          discussionStarter: this.getDiscussionStarter(object, page)
        });
      }

      return r;
    }
  }, {
    key: "getPeople",
    value: function getPeople(object, page) {
      // The original code contains a branch here; right now, it doesn't care about the submitter.
      return null; // But the branch:

      return _Overview.default.getPeople(object, page);
    }
  }, {
    key: "getDiscussionStarter",
    value: function getDiscussionStarter(object, page) {
      var people = this.getPeople(object, page);
      var submitter = people ? people.items.filter(function (item) {
        return item.didSubmit;
      }) : [];

      if (submitter.length != 1) {
        return {
          description: object.description
        };
      }

      return {
        description: object.description,
        date: new Date(this.object.created * 1000).toJSON(),
        id: this.object.id,
        submitter: submitter
      };
    }
  }]);
  return ForumDiscussionTab;
}(_Discussion.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussionStarter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ForumDiscussionTab;